import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent {

}
